export default __webpack_public_path__ + "static/2.4-Colour-Alone-DO_2-ea2de449f96386a5b84d4225445c7bfb.png";